import PropTypes from 'prop-types';
import React from 'react';
import geo2svg from 'geo2svg';
import style from './FieldThumbnail.css';
import { projectCoordinates } from '../../utils/geo';

function FieldThumbnail({
  className,
  geoJson,
  height,
  pinColor,
  pinRadius,
  fillColor,
  strokeColor,
  strokeWidth,
  width,
  regionColor,
  fillOpacity,
  regionFillOpacity,
}) {
  const option = {
    size: [width, height],
    padding: [0, 0, 0, 0],
    output: 'element',
    precision: 3,
  };

  const svgElement = geo2svg(projectCoordinates(geoJson), option);
  const pathElements = Array.from(
    svgElement.children[0].getElementsByTagName('path')
  );
  const pinCx = svgElement.children[0].lastElementChild.getAttribute('cx');
  const pinCy = svgElement.children[0].lastElementChild.getAttribute('cy');

  const thumbnailSvg = (
    <div>
      <svg className={style.fieldThumbnail} height={height} width={width}>
        {pathElements &&
          pathElements.map((element, index) => {
            const fill = index ? regionColor : fillColor;
            const opacity = index ? regionFillOpacity : fillOpacity;
            const stroke = index ? regionColor : strokeColor;
            return (
              <path
                d={element.getAttribute('d')}
                fill={fill}
                fillOpacity={opacity}
                key={element.getAttribute('d')}
                stroke={stroke}
                strokeWidth={strokeWidth}
              />
            );
          })}
        {pinCx && pinCy && (
          <circle cx={pinCx} cy={pinCy} fill={pinColor} r={pinRadius} />
        )}
      </svg>
    </div>
  );

  const thumbnailClassName = className || null;
  return <div className={thumbnailClassName}>{thumbnailSvg}</div>;
}

FieldThumbnail.defaultProps = {
  fillColor: '#AAA',
  height: 40,
  pinColor: '#999',
  pinRadius: 2,
  strokeColor: '#999',
  strokeWidth: 0.5,
  width: 40,
  regionColor: '#AAA',
  fillOpacity: 1,
  regionFillOpacity: 0.3,
};

FieldThumbnail.propTypes = {
  /** className specific for the svg div container */
  className: PropTypes.string,

  /** field thumbnail background color */
  fillColor: PropTypes.string,

  /** field thumbnail fill opacity */
  fillOpacity: PropTypes.number,

  /** geoJson with all the geo data to draw the field thumbnail and pins */
  geoJson: PropTypes.object.isRequired,

  /** field thumbnail height */
  height: PropTypes.number,

  /** color for the pin */
  pinColor: PropTypes.string,

  /** radius for the pin */
  pinRadius: PropTypes.number,

  /** region background color */
  regionColor: PropTypes.string,

  /** region fill opacity */
  regionFillOpacity: PropTypes.number,

  /** field thumbnail border color */
  strokeColor: PropTypes.string,

  /** field thumbnail border width */
  strokeWidth: PropTypes.number,

  /** field thumbnail height */
  width: PropTypes.number,
};

export default FieldThumbnail;
